
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/live",
      function () {
        return require("private-next-pages/sports/ipl/live/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/live"])
      });
    }
  